<!-- Copyright (c) 2023 VMware, Inc. All rights reserved. VMware Confidential -->

<div>
    <button *ngIf="json !== undefined || null"
            class="btn btn-sm btn-outline"
            (click)="downloadObjectAsJson()">
        {{'general.download.json' | vtranslate}}
        <cds-icon shape="download"
                  [attr.aria-hidden]="true"></cds-icon>
    </button>
</div>
<ng-content></ng-content>
